import(/* webpackMode: "eager" */ "/codebuild/output/src264020964/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/app/(public)/[sport]/teams/[team]/[year]/sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src264020964/src/client/src/components/primitives/button.tsx");
